module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-up.75a34141.svg";